import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { systemSettingApi } from '../api/systemSetting.api';
import { systemSettingKeys } from '../api/systemSetting.keys';

export function useSystemSettingList(params: any) {
  return useQuery({
    queryKey: systemSettingKeys.list(params),
    queryFn: () => systemSettingApi.list(params),
    placeholderData: keepPreviousData,
  });
}

export function useSystemSettingDetails(id: any) {
  return useQuery({
    queryKey: systemSettingKeys.detail(id),
    queryFn: () => systemSettingApi.getById(id),
    enabled: !!id,
  });
}
